{
  "dealOutcome": {
    "badge": "Deal: {{status}}",
    "progress": "Deal progress"
  },
  "companyAvatar": {
    "logoAlt": "{{name}} logo",
    "logoAltFallback": "Company logo",
    "initialsLabel": "{{name}} initials",
    "fallbackLabel": "Company"
  },
  "expandableText": {
    "showMore": "Show more",
    "showLess": "Show less"
  },
  "matchExplanation": {
    "title": "Why this match",
    "weight": "weight {{percent}}%"
  },
  "leadSource": {
    "loadError": "Could not load the source options. Please refresh the page.",
    "typeLabel": "How did you hear about us?",
    "select": "Select…",
    "sourceLabel": "Which one?",
    "otherOption": "Other — please specify",
    "detailLabel": "Please specify",
    "detailPlaceholder": "e.g. the name of the organisation, event or person"
  },
  "companyIntent": {
    "loadError": "Could not load the trade options. Please refresh the page.",
    "select": "Select…",
    "sideLabel": "Where is your company based?",
    "sizeLabel": "Company size",
    "rolesLabel": "Your role in trade",
    "rolesHint": "Choose every role that applies.",
    "objectiveLabel": "Main objective",
    "timelineLabel": "Timeline",
    "objectiveDetailsLabel": "Objective details",
    "objectiveDetailsPlaceholder": "e.g. Looking for retail distributors in the UAE",
    "targetRegionsLabel": "Target regions",
    "targetCountriesLabel": "Target countries",
    "addCountry": "Add a country…",
    "removeCountry": "Remove {{country}}",
    "summary": {
      "corridorSide": "Corridor side",
      "tradeRoles": "Trade roles",
      "companySize": "Company size",
      "objective": "Objective",
      "objectiveDetails": "Objective details",
      "targetRegions": "Target regions",
      "targetCountries": "Target countries",
      "timeline": "Timeline"
    }
  },
  "usageSummary": {
    "currentPlan": "Current plan",
    "defaultPlan": "Default plan.",
    "creditBased": "Requests beyond the allowance use credits.",
    "creditBalance": "Credits",
    "creditMeaning": "1 credit = 1 match request.",
    "billingCurrency": "Billing currency",
    "billingCurrencyUnset": "Not set",
    "billingCurrencyHint": "Set from your corridor side at approval.",
    "period": "Usage in {{month}}",
    "table": {
      "metric": "Usage",
      "used": "Used",
      "limit": "Limit"
    },
    "metrics": {
      "requests": "Match requests submitted",
      "matches": "Matches produced",
      "activeDeals": "Active deals"
    },
    "unlimited": "Unlimited"
  }
}
